import variables from "../../../_constants/variables";
import localOrSessionStore from "../../../_helpers/localOrSessionStore";
import MyFolderStudentView from "./myFolder.student.view";
import "./myFolder.scss"

const MyFolder = () =>{
    const storage = localOrSessionStore({key: variables.REMEMBER});
    const userType = storage.getItem(variables.USER_TYPE);

    //return (userType==='STUDENT'?<MyFolderStudentView/>:<MyFolderStudentView/>)

    return <MyFolderStudentView/>
}

export default MyFolder;
